/* =========================================================================================
  File Name:
  Description:
  ----------------------------------------------------------------------------------------
  Item Name: GetBoarded UI Template
  Author: GetBoarded
  Author URL: https://www.getboarded.com
========================================================================================== */


export default {
  ADD_ITEM(state, item) {
    // If notes array doesn't exist yet, create it first!
    if (!state.notes) {
      state.notes = [];
    }
    state.notes.push(item);
  },
  SET_NOTES (state, notes) {
    state.notes = notes
  },
  REMOVE_RECORD (state, itemId) {
    const noteIndex = state.notes.findIndex((u) => u.id === itemId)
    state.notes.splice(noteIndex, 1)
  }
}
